import { useEffect } from 'react'
import { Spinner } from '@epam/loveship'
import { ReviewTypeEnum } from '../../../../constants/enums'
import {
  useGetPointReviewQuery,
  useGetPointQuery,
  useGetLayersQuery,
} from '../../../../store'
import { PointDetails } from '../PointDetails/PointDetails'
import { Reviews } from '../Reviews/Reviews'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { useSideBarControlls } from '../../../../hooks/useSideBarControlls'

type PointInfoProps = {
  pointId: number
}

export const PointInfo = ({ pointId }: PointInfoProps) => {
  const { data: layers } = useGetLayersQuery()
  const { data: points, refetch: refetchPoint } = useGetPointQuery(pointId)
  const {
    data: reviews,
    refetch: refetchReviews,
    isLoading,
  } = useGetPointReviewQuery(pointId)
  const { isSideBarCloseInitiated } = useAppSelector((state) => state.app)
  const { closeSideBar } = useSideBarControlls()
  const layer = layers?.find((layer) => layer.id === points?.[0].layerId)

  useEffect(() => {
    if (isSideBarCloseInitiated) closeSideBar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSideBarCloseInitiated])

  return (
    <>
      {points && points.length > 0 && (
        <>
          <PointDetails
            point={points[0]}
            pointCategory={layer?.name}
            reviews={reviews}
          />
          {isLoading ? (
            <Spinner />
          ) : (
            <Reviews
              itemId={points[0].id}
              itemRating={points[0].rating}
              itemType={layer?.name}
              itemName={points[0].name}
              type={ReviewTypeEnum.point}
              refetchItems={() => refetchPoint()}
              refetchReviews={() => refetchReviews()}
              reviews={reviews}
            />
          )}
        </>
      )}
    </>
  )
}
